/**
 * Body scroll lock with reference counting, so a sheet opened from inside a
 * dialog does not restore scrolling when only the inner surface closes.
 */
let activeLocks = 0;
let previousOverflow = '';

/** Locks body scrolling and returns an idempotent release function. */
export function lockBodyScroll(): () => void {
  if (typeof document === 'undefined') return () => {};

  if (activeLocks === 0) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  activeLocks += 1;

  let released = false;
  return () => {
    if (released) return;
    released = true;
    activeLocks -= 1;
    if (activeLocks === 0) {
      document.body.style.overflow = previousOverflow;
      previousOverflow = '';
    }
  };
}
